
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[nonprofitSlugOrUsername]/fundraiser",
      function () {
        return require("private-next-pages/[nonprofitSlugOrUsername]/fundraiser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[nonprofitSlugOrUsername]/fundraiser"])
      });
    }
  